import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import useAuthStore from '../store/useAuthStore';
import useChatStore from '../store/useChatStore';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { db } from '../lib/firebase';
import OmniIcon from './icons/OmniIcon';

// Icons
const HomeIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" /></svg>;
const FolderIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 00-1.883 2.542l.857 6a2.25 2.25 0 002.227 1.932H19.05a2.25 2.25 0 002.227-1.932l.857-6a2.25 2.25 0 00-1.883-2.542m-16.5 0V6A2.25 2.25 0 016 3.75h3.879a1.5 1.5 0 011.06.44l2.122 2.12a1.5 1.5 0 001.06.44H18A2.25 2.25 0 0120.25 9v.776" /></svg>;
const SettingsIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 010 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 010-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z" /><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0Z" /></svg>;
const TasksIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 010 3.75H5.625a1.875 1.875 0 010-3.75z" /></svg>;
const AgentsIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" /></svg>;
const ComputerDesktopIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 17.25v1.007a3 3 0 01-.879 2.122L7.5 21h9l-.621-.621A3 3 0 0115 18.257V17.25m6-12V15a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 15V5.25m18 0A2.25 2.25 0 0018.75 3H5.25A2.25 2.25 0 003 5.25m18 0V12a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 12V5.25" /></svg>;
const MenuIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" /></svg>;
const CloseIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>;
const ConversationIcon = ({ className }) => (
    <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M13 8H7M17 12H7" />
    </svg>
);
const PowerIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M5.636 5.636a9 9 0 1012.728 0M12 3v9" /></svg>;
const SunIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M3 12h2.25m.386-6.364l1.591 1.591M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" /></svg>;
const MoonIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M21.75 12.838A9.993 9.993 0 0112 21.75c-5.523 0-10-4.477-10-10a9.993 9.993 0 018.912-9.94c.459-.052.887.276.96.733a1.023 1.023 0 01-.173.743c-.09.124-.208.232-.347.317a7.5 7.5 0 109.94 8.912c.085-.139.193-.257.317-.347a1.023 1.023 0 011.476.787z" /></svg>;
const ChevronRightIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" /></svg>;
const TrashIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M14.74 9l-.34 9m-4.74 0l-.34-9m4.74-3H9m3.71-2H11.29a1 1 0 00-.99 1.01L10.32 4H13.68l.02-1.01a1 1 0 00-.99-1.01zM19 6H5m2 0h10l-.82 12.5a2 2 0 01-1.99 1.94H9.81a2 2 0 01-1.99-1.94L7 6z" /></svg>;
const HistoryIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;

const SidebarLayout = () => {
    const { user, profile, logout } = useAuthStore();
    const { standaloneChats, subscribeToStandaloneChats, deleteChat } = useChatStore();
    const location = useLocation();
    const navigate = useNavigate();
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
    const [isModeSubMenuOpen, setIsModeSubMenuOpen] = useState(false);
    const [allDevices, setAllDevices] = useState([]);
    const [onlineCount, setOnlineCount] = useState(0);
    const [isConversationsExpanded, setIsConversationsExpanded] = useState(() => {
        const saved = localStorage.getItem('sidebar_conversations_expanded');
        return saved !== null ? JSON.parse(saved) : true;
    });

    // Add localStorage persistence effect.
    useEffect(() => {
        localStorage.setItem('sidebar_conversations_expanded', JSON.stringify(isConversationsExpanded));
    }, [isConversationsExpanded]);

    const menuRef = useRef(null);

    // Close menu when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsProfileMenuOpen(false);
                setIsModeSubMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        if (!user) return;
        const sub = subscribeToStandaloneChats();
        return () => sub && sub();
    }, [user, subscribeToStandaloneChats]);

    // Listen to devices for online count
    useEffect(() => {
        if (!user) return;
        const q = query(collection(db, 'users', user.uid, 'devices'));
        return onSnapshot(q, (snap) => {
            setAllDevices(snap.docs.map(d => d.data()));
        });
    }, [user]);

    // Pulse the online count periodically
    useEffect(() => {
        const update = () => {
            const now = new Date();
            const count = allDevices.filter(d => {
                if (!d.last_seen) return false;
                const diff = (now - d.last_seen.toDate()) / 1000;
                return diff < 60;
            }).length;
            setOnlineCount(count);
        };
        update();
        const interval = setInterval(update, 10000);
        return () => clearInterval(interval);
    }, [allDevices]);

    // Don't render sidebar shell on public auth routes
    if (!user) return <Outlet />;

    // Helper for active styling
    const navLinkClass = ({ isActive }) =>
        `flex items-center gap-3 px-3 py-1.5 rounded-lg transition-[background-color,color,transform,box-shadow] duration-200 font-medium text-[13px] border border-transparent focus:outline-none focus:ring-0 focus-visible:ring-0 ${isActive
            ? 'bg-[var(--bg-tertiary)] text-[var(--accent-primary)] font-medium border-[var(--border-subtle)] shadow-sm'
            : 'text-[var(--text-muted)] hover:text-[var(--text-main)] hover:bg-[var(--bg-tertiary)]/50'
        }`;

    const SidebarContent = (
        <div className="flex flex-col h-full bg-[var(--bg-secondary)] w-full pt-6 pb-6 px-2.5 transition-all">
            {/* Logo / Header */}
            <div className="flex items-center gap-2.5 px-2 mb-10 mt-2">
                <div className="shrink-0">
                    <OmniIcon className="w-8 h-8 text-[var(--text-main)]" />
                </div>
                <h2 className="text-base font-semibold tracking-tight text-[var(--text-main)]">Omni</h2>
            </div>

            {/* Main Navigation */}
            <nav className="flex-1 space-y-1">
                <NavLink to="/" className={navLinkClass} onClick={() => setIsMobileOpen(false)}>
                    <HomeIcon className="w-5 h-5 shrink-0" />
                    Home
                </NavLink>
                <NavLink to="/projects" className={navLinkClass} onClick={() => setIsMobileOpen(false)}>
                    <FolderIcon className="w-5 h-5 shrink-0" />
                    Spaces
                </NavLink>
                <NavLink to="/agents" className={navLinkClass} onClick={() => setIsMobileOpen(false)}>
                    <AgentsIcon className="w-5 h-5 shrink-0" />
                    Agents
                </NavLink>
                <NavLink to="/devices" className={navLinkClass} onClick={() => setIsMobileOpen(false)}>
                    <ComputerDesktopIcon className="w-5 h-5 shrink-0" />
                    <span className="flex-1">Devices</span>
                    {onlineCount > 0 && (
                        <div className="flex items-center gap-1.5 px-1.5 py-0.5 rounded-full bg-green-500/10 border border-green-500/20 shadow-sm animate-in fade-in zoom-in-95 duration-300">
                            <div className="w-1.5 h-1.5 rounded-full bg-green-500 shadow-[0_0_8px_rgba(34,197,94,0.6)] animate-pulse" />
                            <span className="text-[10px] font-bold text-green-500 leading-none">{onlineCount}</span>
                        </div>
                    )}
                </NavLink>
                <NavLink to="/tasks" className={navLinkClass} onClick={() => setIsMobileOpen(false)}>
                    <TasksIcon className="w-5 h-5 shrink-0" />
                    Tasks
                </NavLink>

                {/* Collapsible Conversations Section */}
                <div className="space-y-0.5">
                    <div className="flex items-center group">
                        <NavLink to="/history" className={(props) => `${navLinkClass(props)} flex-1 pr-10`} onClick={() => setIsMobileOpen(false)}>
                            <ConversationIcon className="w-5 h-5 shrink-0" />
                            <span className="flex-1">Conversations</span>
                        </NavLink>
                        <button
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setIsConversationsExpanded(!isConversationsExpanded);
                            }}
                            className={`absolute right-4 p-1 rounded-md hover:bg-[var(--bg-tertiary)] text-[var(--text-muted)] hover:text-[var(--text-main)] transition-all z-20 ${isConversationsExpanded ? 'rotate-90' : ''}`}
                            title={isConversationsExpanded ? "Collapse" : "Expand"}
                        >
                            <ChevronRightIcon className="w-4 h-4" />
                        </button>
                    </div>

                    {isConversationsExpanded && standaloneChats.length > 0 && (
                        <div className="mt-1 flex flex-col min-h-0 animate-in fade-in slide-in-from-top-1 duration-200">
                            <div className="flex-1 overflow-y-auto custom-scrollbar pr-1 max-h-[40vh]">
                                <div className="space-y-0.5 ml-1.5 border-l border-[var(--border-subtle)] pl-1">
                                    {standaloneChats.slice(0, 10).map(chat => (
                                        <NavLink
                                            key={chat.id}
                                            to={`/chat/${chat.id}`}
                                            onClick={() => setIsMobileOpen(false)}
                                            className={({ isActive }) =>
                                                `flex items-center gap-2.5 px-3 py-1.5 rounded-lg transition-[background-color,color] duration-200 group border border-transparent focus:ring-0 focus-visible:ring-0 ${isActive ? 'bg-[var(--bg-tertiary)] text-[var(--accent-primary)] border-[var(--border-subtle)]' : 'text-[var(--text-muted)] hover:bg-[var(--bg-tertiary)]/50 hover:text-[var(--text-main)]'}`
                                            }
                                        >
                                            <ConversationIcon className="w-3.5 h-3.5 shrink-0 opacity-60 group-hover:opacity-100" />
                                            <span className="text-[13px] font-medium truncate leading-tight flex-1">
                                                {chat.title || 'Untitled Conversation'}
                                            </span>
                                        </NavLink>
                                    ))}
                                    {standaloneChats.length > 10 && (
                                        <NavLink to="/history" className="flex items-center gap-2.5 px-3 py-1.5 rounded-lg text-[11px] font-bold text-indigo-400/80 hover:text-indigo-400 transition-colors uppercase tracking-widest pl-9" onClick={() => setIsMobileOpen(false)}>
                                            See All
                                        </NavLink>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </nav>

            {/* Bottom Actions */}
            <div className="mt-auto relative" ref={menuRef}>
                {/* Popover Menu */}
                {isProfileMenuOpen && (
                    <div className="absolute bottom-full left-2 right-2 mb-3 bg-[var(--panel-bg)] backdrop-blur-xl border border-[var(--border-medium)] rounded-2xl shadow-2xl overflow-visible py-2 z-50 animate-in fade-in slide-in-from-bottom-2 duration-200">
                        <div className="px-3 py-2 mb-1 border-b border-[var(--border-subtle)]">
                            <p className="text-[11px] font-semibold text-[var(--text-dim)] uppercase tracking-widest">Account</p>
                        </div>

                        <NavLink
                            to="/settings"
                            onClick={() => setIsProfileMenuOpen(false)}
                            className="flex items-center gap-3 px-3 py-2.5 text-sm font-medium text-[var(--text-muted)] hover:text-[var(--text-main)] hover:bg-[var(--bg-tertiary)]/50 transition-all w-full text-left group"
                        >
                            <SettingsIcon className="w-5 h-5 shrink-0 transition-transform group-hover:rotate-12" />
                            <span>Settings</span>
                        </NavLink>

                        {/* Mode Sub-menu Trigger */}
                        <div
                            className="relative"
                            onMouseEnter={() => !window.matchMedia('(max-width: 768px)').matches && setIsModeSubMenuOpen(true)}
                            onMouseLeave={() => !window.matchMedia('(max-width: 768px)').matches && setIsModeSubMenuOpen(false)}
                        >
                            <button
                                onClick={() => window.matchMedia('(max-width: 768px)').matches && setIsModeSubMenuOpen(!isModeSubMenuOpen)}
                                className={`flex items-center gap-3 px-3 py-2.5 text-sm font-medium transition-all w-full text-left ${isModeSubMenuOpen ? 'text-[var(--text-main)] bg-[var(--bg-tertiary)]/50' : 'text-[var(--text-muted)] hover:text-[var(--text-main)] hover:bg-[var(--bg-tertiary)]/50'}`}
                            >
                                {profile?.theme === 'light' ? (
                                    <SunIcon className="w-5 h-5 shrink-0" />
                                ) : (
                                    <MoonIcon className="w-5 h-5 shrink-0" />
                                )}
                                <span className="flex-1">Mode</span>
                                <ChevronRightIcon className={`w-3.5 h-3.5 transition-transform duration-300 ${isModeSubMenuOpen ? 'rotate-90 translate-x-1' : 'opacity-40'}`} />
                            </button>

                            {/* Responsive Sub-menu: Popout on Desktop, Accordion on Mobile */}
                            {isModeSubMenuOpen && (
                                <div className="md:absolute md:left-full md:bottom-0 md:pl-2 z-[60] relative left-0 bottom-0 pl-0 w-full animate-in fade-in slide-in-from-left-2 md:duration-150 duration-200">
                                    {/* Invisible Bridge (Desktop Only) */}
                                    <div className="hidden md:block absolute left-0 top-0 bottom-0 w-2 bg-transparent" />

                                    <div className="md:w-44 w-full bg-[var(--panel-bg)] md:backdrop-blur-2xl border md:border-[var(--border-medium)] border-transparent md:rounded-2xl rounded-lg md:shadow-2xl py-1 mt-1 md:mt-0">
                                        <div className="hidden md:block px-3 py-1.5 mb-1 border-b border-[var(--border-subtle)] font-sans">
                                            <p className="text-[10px] font-semibold text-[var(--text-dim)] uppercase tracking-widest text-center">Appearance</p>
                                        </div>
                                        <button
                                            onClick={() => {
                                                useAuthStore.getState().setTheme('light');
                                                if (window.matchMedia('(max-width: 768px)').matches) {
                                                    setIsProfileMenuOpen(false);
                                                }
                                                setIsModeSubMenuOpen(false);
                                            }}
                                            className={`flex items-center gap-3 px-4 md:px-3 py-2.5 text-sm font-medium w-full text-left transition-all ${profile?.theme === 'light' ? 'text-[var(--accent-primary)] bg-[var(--bg-tertiary)]/80 shadow-inner' : 'text-[var(--text-muted)] hover:text-[var(--text-main)] hover:bg-[var(--bg-tertiary)]/50'}`}
                                        >
                                            <div className="relative">
                                                <SunIcon className="w-4.5 h-4.5" />
                                                {profile?.theme === 'light' && <div className="absolute -top-1 -right-1 w-2 h-2 bg-[var(--accent-primary)] rounded-full animate-pulse" />}
                                            </div>
                                            <span className="flex-1">Light Mode</span>
                                            {profile?.theme === 'light' && <div className="w-1.5 h-1.5 rounded-full bg-[var(--accent-primary)]" />}
                                        </button>
                                        <button
                                            onClick={() => {
                                                useAuthStore.getState().setTheme('dark');
                                                if (window.matchMedia('(max-width: 768px)').matches) {
                                                    setIsProfileMenuOpen(false);
                                                }
                                                setIsModeSubMenuOpen(false);
                                            }}
                                            className={`flex items-center gap-3 px-4 md:px-3 py-2.5 text-sm font-medium w-full text-left transition-all ${profile?.theme === 'dark' ? 'text-[var(--accent-primary)] bg-[var(--bg-tertiary)]/80 shadow-inner' : 'text-[var(--text-muted)] hover:text-[var(--text-main)] hover:bg-[var(--bg-tertiary)]/50'}`}
                                        >
                                            <div className="relative">
                                                <MoonIcon className="w-4.5 h-4.5" />
                                                {profile?.theme === 'dark' && <div className="absolute -top-1 -right-1 w-2 h-2 bg-[var(--accent-primary)] rounded-full animate-pulse" />}
                                            </div>
                                            <span className="flex-1">Dark Mode</span>
                                            {profile?.theme === 'dark' && <div className="w-1.5 h-1.5 rounded-full bg-[var(--accent-primary)]" />}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="mt-1 border-t border-[var(--border-subtle)] pt-1">
                            <button
                                onClick={async () => {
                                    setIsProfileMenuOpen(false);
                                    await logout();
                                }}
                                className="flex items-center gap-3 px-3 py-2.5 text-sm font-medium text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-all w-full text-left group"
                            >
                                <PowerIcon className="w-5 h-5 shrink-0 transition-transform group-hover:scale-110" />
                                <span>Sign Out</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* User Profile Trigger */}
                <div
                    onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                    className="px-3 py-2.5 rounded-xl hover:bg-[var(--bg-tertiary)]/50 transition-all cursor-pointer flex items-center gap-3 border border-transparent hover:border-[var(--border-subtle)] active:scale-[0.98]"
                >
                    <div className="w-8 h-8 rounded-full border border-[var(--border-subtle)] overflow-hidden shrink-0 bg-[var(--bg-secondary)]">
                        {profile?.photoURL ? (
                            <img src={profile.photoURL} alt="Profile" className="w-full h-full object-cover" />
                        ) : (
                            <div className="w-full h-full flex items-center justify-center text-slate-400 text-xs font-bold">
                                {profile?.displayName?.charAt(0).toUpperCase() || user.email?.charAt(0).toUpperCase()}
                            </div>
                        )}
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="text-sm font-semibold text-[var(--text-main)] truncate">{profile?.displayName || 'User'}</p>
                        <p className="text-[10px] text-[var(--text-muted)] truncate">{user.email}</p>
                    </div>
                    <svg className={`w-3.5 h-3.5 text-[var(--text-muted)] shrink-0 transition-transform duration-200 ${isProfileMenuOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                    </svg>
                </div>
            </div>
        </div>
    );

    return (
        <div className={`flex bg-[var(--bg-main)] text-[var(--text-main)] min-h-[100dvh] transition-colors duration-300 ${user?.theme === 'light' ? 'light-theme' : ''}`}>
            {/* Desktop Sidebar (Fixed) */}
            <aside className="hidden md:flex flex-col w-60 fixed inset-y-0 z-50 border-r border-[var(--border-subtle)] bg-[var(--bg-main)]">
                {SidebarContent}
            </aside>

            {/* Mobile Header & Overlay Trigger */}
            <div className="md:hidden fixed top-0 left-0 right-0 h-14 bg-[var(--bg-secondary)] backdrop-blur-lg border-b border-[var(--border-subtle)] z-40 flex items-center px-4">
                <button
                    onClick={() => setIsMobileOpen(true)}
                    className="p-2 -ml-2 text-[var(--text-muted)] hover:text-[var(--text-main)] focus:outline-none"
                >
                    <MenuIcon className="w-6 h-6" />
                </button>
                <h1 className="ml-2 font-bold text-[var(--text-main)] tracking-tight">Omni</h1>
            </div>

            {/* Mobile Sidebar Overlay */}
            {isMobileOpen && (
                <div className="md:hidden fixed inset-0 z-50 flex">
                    <div
                        className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
                        onClick={() => setIsMobileOpen(false)}
                    />
                    <div className="relative w-64 bg-[var(--bg-secondary)] h-full shadow-2xl animate-in slide-in-from-left duration-250 flex flex-col border-r border-[var(--border-subtle)]">
                        <button
                            onClick={() => setIsMobileOpen(false)}
                            className="absolute top-4 right-4 z-[60] p-2 text-[var(--text-muted)] hover:text-[var(--text-main)] transition-colors focus:outline-none bg-[var(--bg-tertiary)]/50 rounded-full"
                        >
                            <CloseIcon className="w-5 h-5" />
                        </button>
                        <div className="flex-1 overflow-y-auto">
                            {SidebarContent}
                        </div>
                    </div>
                </div>
            )}

            {/* Main Content Area */}
            <main className="flex-1 flex flex-col md:pl-60 min-w-0 min-h-[100dvh] transition-all">
                {/* Mobile Spacer */}
                <div className="h-14 md:hidden shrink-0" />

                <div className="flex-1 relative">
                    {/* The specific page content is injected here */}
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default SidebarLayout;
